/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerInsuranceType } from './ScreenerInsuranceType';
import {
    ScreenerInsuranceTypeFromJSON,
    ScreenerInsuranceTypeFromJSONTyped,
    ScreenerInsuranceTypeToJSON,
} from './ScreenerInsuranceType';

/**
 * 
 * @export
 * @interface FacilityInnTypes
 */
export interface FacilityInnTypes {
    /**
     * 
     * @type {string}
     * @memberof FacilityInnTypes
     */
    facility_id: string;
    /**
     * 
     * @type {Array<ScreenerInsuranceType>}
     * @memberof FacilityInnTypes
     */
    inn_types: Array<ScreenerInsuranceType>;
    /**
     * 
     * @type {string}
     * @memberof FacilityInnTypes
     */
    network_status: FacilityInnTypesNetworkStatusEnum;
}


/**
 * @export
 */
export const FacilityInnTypesNetworkStatusEnum = {
    InNetwork: 'in_network',
    OutOfNetwork: 'out_of_network'
} as const;
export type FacilityInnTypesNetworkStatusEnum = typeof FacilityInnTypesNetworkStatusEnum[keyof typeof FacilityInnTypesNetworkStatusEnum];


/**
 * Check if a given object implements the FacilityInnTypes interface.
 */
export function instanceOfFacilityInnTypes(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "inn_types" in value;
    isInstance = isInstance && "network_status" in value;

    return isInstance;
}

export function FacilityInnTypesFromJSON(json: any): FacilityInnTypes {
    return FacilityInnTypesFromJSONTyped(json, false);
}

export function FacilityInnTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityInnTypes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'inn_types': ((json['inn_types'] as Array<any>).map(ScreenerInsuranceTypeFromJSON)),
        'network_status': json['network_status'],
    };
}

export function FacilityInnTypesToJSON(value?: FacilityInnTypes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
        'inn_types': ((value.inn_types as Array<any>).map(ScreenerInsuranceTypeToJSON)),
        'network_status': value.network_status,
    };
}

